import Vue from 'vue'
import Vuex from 'vuex'

import breadcrumbs from './modules/breadcrumbs'
import clients from './modules/clients'
import config from './modules/config'
import groups from './modules/groups'
import physicians from './modules/physicians'
import options from './modules/options'
import perms from './modules/perms'
import user from './modules/user'

Vue.use(Vuex);


export default new Vuex.Store({
    strict: true,

    modules: {
    	breadcrumbs,
    	clients,
    	config,
        groups,
    	physicians,
        options,
        perms,
        user,
    },
})